module.exports = __webpack_public_path__ + "img/oem5.22c52535.png";